/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Main from "components/main";
import Section from "components/section";
import DocumentHead from "data/document-head";
import FormFieldset from "components/forms/form-fieldset";
import FormLabel from "components/forms/form-label";
import FormTextInput from "components/forms/form-text-input";
import Navigation from "modules/me/navigation";
import {
  getCurrentUserBusinessName,
  getCurrentUsername,
  getCurrentUserEmail,
} from "state/current-user/selectors";
import PageHeader from "layout/page-header";
import SettingsRow from "modules/me/setting-row";
import SettingsGroup from "modules/me/setting-row/settings-group";
import { successNotice, errorNotice } from "state/notices/actions";

/**
 * Style dependencies
 */
import "./styles.scss";
import { useActivePartnerProvider } from "../../../data/active-partner-provider/hooks";
import vdcom from "lib/vd";

const Profile = ({ ...props }) => {
  const { partner, setActivePartner } = useActivePartnerProvider();

  const handleOnTimezoneChange = (timeZone) => {
    vdcom
      .partner()
      .update({
        timeZone: timeZone,
      })
      .then((result) => {
        setActivePartner(result);
        props.successNotice("Update successfull");
        console.log("FINDME", result);
      })
      .catch((err) => {
        console.log(err);
        props.errorNotice("Failed to save preferences");
      });
  };

  return (
    <>
      <PageHeader title="Settings" />
      <Main>
        <DocumentHead title="Profile" />
        <Navigation section="profile" />
        <Section label="Profile">
          <form>
            <FormFieldset>
              <FormLabel htmlFor="business_name">
                <Text size="xsmall" weight="medium">
                  Business Name
                </Text>
              </FormLabel>
              <FormTextInput
                disabled={true}
                name="business_name"
                value={props.businessName}
              />
            </FormFieldset>
            <FormFieldset>
              <FormLabel htmlFor="business_name">
                <Text size="xsmall" weight="medium">
                  Email
                </Text>
              </FormLabel>
              <FormTextInput disabled={true} name="email" value={props.email} />
            </FormFieldset>
            <FormFieldset>
              <FormLabel htmlFor="username">
                <Text size="xsmall" weight="medium">
                  Username
                </Text>
              </FormLabel>
              <FormTextInput
                disabled={true}
                name="username"
                value={props.username}
              />
            </FormFieldset>
          </form>
        </Section>
        <Section title="Configuration" padded={false}>
          <SettingsGroup>
            <SettingsRow label="Time Zone">
              <select
                defaultValue={partner.timeZone}
                onChange={(e) => handleOnTimezoneChange(e.target.value)}
                value={partner.timeZone}
              >
                {[
                  {
                    value: "Australia/Melbourne",
                    label: "Melbourne / Sydney",
                  },
                  {
                    value: "Australia/Brisbane",
                    label: "Brisbane",
                  },
                  {
                    value: "Australia/Perth",
                    label: "Perth",
                  },
                  {
                    value: "Australia/Adelaide",
                    label: "Adelaide",
                  },
                  {
                    value: "Australia/Darwin",
                    label: "Darwin",
                  },
                  {
                    value: "Pacific/Auckland",
                    label: "Auckland",
                  },
                ].map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </SettingsRow>
          </SettingsGroup>
        </Section>
      </Main>
    </>
  );
};

export default connect(
  (state) => {
    return {
      username: getCurrentUsername(state),
      email: getCurrentUserEmail(state),
      businessName: getCurrentUserBusinessName(state),
    };
  },
  {
    successNotice,
    errorNotice,
  }
)(Profile);
